export default __webpack_public_path__ + "static/media/profile_pic1.34ea98b4.svg";